import { motion } from "framer-motion";
import { Link } from "react-router-dom";
import { Button } from "@/components/ui/button";
import { ArrowRight, CheckCircle2 } from "lucide-react";
export function CTASection() {
  return <section className="section-padding">
      <div className="container-custom">
        <motion.div initial={{
        opacity: 0,
        scale: 0.95
      }} whileInView={{
        opacity: 1,
        scale: 1
      }} viewport={{
        once: true
      }} className="relative overflow-hidden rounded-3xl bg-gradient-to-br from-secondary via-secondary to-secondary/80 p-8 md:p-16 text-center">
          {/* Background decorations */}
          <div className="absolute top-0 left-0 w-64 h-64 bg-white/10 rounded-full blur-3xl -translate-x-1/2 -translate-y-1/2" />
          <div className="absolute bottom-0 right-0 w-64 h-64 bg-white/10 rounded-full blur-3xl translate-x-1/2 translate-y-1/2" />

          <div className="relative z-10">
            <h2 className="text-3xl md:text-4xl lg:text-5xl font-heading font-bold text-secondary-foreground mb-4">
              ¿Listo para olvidarte del SAT?
            </h2>
            <p className="text-lg md:text-xl text-secondary-foreground/80 mb-8 max-w-2xl mx-auto">Únete a los cientos de profesionistas que ya disfrutan de impuestos simples por solo $350/mes</p>

            <div className="flex flex-wrap justify-center gap-4 mb-8">
              {["Sin contratos", "Cancela cuando quieras", "Soporte por WhatsApp"].map((item, i) => <div key={i} className="flex items-center gap-2 text-secondary-foreground/90">
                  <CheckCircle2 className="w-5 h-5" />
                  <span>{item}</span>
                </div>)}
            </div>

            <div className="flex flex-col sm:flex-row items-center justify-center gap-4">
              <Button size="lg" className="bg-primary text-primary-foreground hover:bg-primary/90 text-base px-8 group" asChild>
                <Link to="/registro">
                  Comienza gratis ahora
                  <ArrowRight className="w-5 h-5 ml-2 group-hover:translate-x-1 transition-transform" />
                </Link>
              </Button>
              <Button size="lg" variant="outline" className="border-secondary-foreground/30 text-secondary-foreground hover:bg-secondary-foreground/10 text-base px-8" asChild>
                <Link to="/contacto">Agenda una llamada</Link>
              </Button>
            </div>
          </div>
        </motion.div>
      </div>
    </section>;
}